
<div class="container-fluid  container-box" [ngClass]="{'codecrosswalk-width': currentTab == tabName.CODECROSSWALK_TAB && isPreviewTabOpen,'duplicate-width': currentTab == tabName.CODECROSSWALK_TAB && isDuplicate}">
  <app-duplicates-tab *ngIf="isDuplicate" [actWidth]="actWidth" [potentialError]="potentialError" [valid]="isDisabled" (navToError)="reloadData($event)"></app-duplicates-tab>
  <app-preview-tab *ngIf="isPreviewTabOpen"></app-preview-tab>
</div>
<div *ngIf="defaultView" class="container-fluid  container-box ps-0" [ngClass]="{'loaderShow': isDataLoading, 'default-width': defaultView && currentTab == tabName.CODECROSSWALK_TAB }">
  <div  *ngIf="importError" [style]="{'height': flexHeight}">
    <div class="row row-gap-2 mt-3 mx-0 position-relative justify-content-center">
      <div class="d-flex px-0" [style.width.px]="actWidth">
       <div class="col-12 col-md-4">
        <span class="text-semi-primary no-error">No errors detected.</span>
       </div>
      </div>
    </div>
  </div>
  <div class="grid-box">
     <app-ag-grid 
       class="center-Pagination d-block position-relative minHeightSet"
       [ngStyle]="{'height': flexHeight}" 
       [dataModel]="dataModel" 
       [paginations]="false"
       [columnSettings]="false"
       (gridReady)="onGridReady($event)" 
       >
    </app-ag-grid>
  <app-custom-loader *ngIf="!importError" class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
  </div>


<div class="row row-gap-2 mt-3 mx-0 position-relative justify-content-center">
  <div class="d-flex px-0 flex-wrap justify-content-end" [style.width.px]="actWidth">
    <div *ngIf="!importError" class="col-12 col-md-4 error-box">
      <div class="font-11 text-red fw-bold">You have {{rowData?.length}} errors</div>
      <div class="font-11 text-light-gray">Error rows do not get imported.</div>
    </div>
    <div class="col-11 wrapper mt-5 mt-sm-0 {{importError ? 'col-md-11 d-flex justify-content-center justify-content-sm-end' : 'col-md-8'}}">
      <div class="footer-box" >
        <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB"
        class="px-1 px-sm-2"
        [button_2]="true"
        [buttonClass]="'button button-info mx-0'"
        [buttonLable]="enumButtonName.CANCEL"
        (click)="closeTab()"
        >
       </app-button>
       <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB"
       class="px-1 px-sm-2"
       [button_2]="true"
       [buttonClass]="'button button-info mx-0'"
       [buttonLable]="enumButtonName.CANCEL"
       (click)="close()"
       >
      </app-button>
       <!-- <app-button
       *ngIf="isDuplicate"
         progressStepNext
         class="ps-2 pe-10"
         [button_2]="true"
         [buttonClass]="'button  dark-info mx-0'"
         [buttonLable]="enumButtonName.APPLYCHANGES"
         (click)="applyChanges()"
         >
       </app-button> -->
       <button #prevCallButton id="prevCall" progressStepPrev (click)="previousCall();isDataLoading = false" class="button dark-info mx-1 mx-sm-2">Previous</button>
  
       <!-- <app-button
       #prevCall
       progressStepPrev
      class="px-2"
      [button_2]="true"
      [buttonClass]="'button  dark-info mx-0'"
      [buttonLable]="enumButtonName.PREVIOUS"
      (click)="previousCall(); "
     >
     </app-button> -->
       <app-button 
         class="ps-2"
         [button_2]="true"
         [buttonClass]="importDocumentsService.submit?'button button-primary mx-0':'button  dark-info mx-0'"
         [buttonLable]="enumButtonName.NEXT"
         (click)="isDisabled?null:handleClick()"
         [inputReadonly]="isDisabled"
         >
       </app-button>
      </div>
    </div>
  </div>
 </div>
</div>
<app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isDataLoading"></app-custom-loader>
